import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "preloader-area",
  id: "preloader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "loader" }, [
          _createElementVNode("div", { class: "waviy" }, [
            _createElementVNode("span", null, "M"),
            _createElementVNode("span", null, "A"),
            _createElementVNode("span", null, "Z"),
            _createElementVNode("span", null, "I"),
            _createElementVNode("span", null, "I")
          ])
        ], -1)
      ])))
    : _createCommentVNode("", true)
}